import { render } from "./TaxSettModal.vue?vue&type=template&id=699fe65b&ts=true"
import script from "./TaxSettModal.vue?vue&type=script&lang=ts"
export * from "./TaxSettModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__